import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useSupabaseUser,
} from "#imports";

export default defineNuxtRouteMiddleware(() => {
  const user = useSupabaseUser();

  // Giriş yapılmamışsa
  if (!user.value) {
    return navigateTo("/");
  }

  // Admin değilse
  const isAdmin = user.value.user_metadata?.is_admin === true;
  if (!isAdmin) {
    return navigateTo("/403"); // veya ana sayfa
  }
});
